{
    "name": "doerr-wildkamera-admin",
    "version": "3.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --configuration=development --hmr",
        "start:test": "ng serve --configuration=test",
        "build": "ng build",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "build:test": "grunt clean && node --max-old-space-size=4192 ./node_modules/@angular/cli/bin/ng build --configuration=test --verbose && grunt build_docker",
        "build:production": "grunt clean && node --max-old-space-size=4192 ./node_modules/@angular/cli/bin/ng build --configuration=production --verbose && grunt build",
        "format": "prettier 'src/**/*.{js,jsx,ts,tsx,html,css,scss}' 'e2e/**/*.{js,jsx,ts,tsx,html,css,scss}' --write"
    },
    "private": true,
    "browserslist": [
        "last 1 Chrome version",
        "last 1 Firefox version",
        "last 2 Edge major versions",
        "last 2 Safari major versions",
        "last 2 iOS major versions",
        "Firefox ESR",
        "not IE 11"
    ],
    "engines": {
        "node": ">=24.11.0 <25"
    },
    "dependencies": {
        "@angular/animations": "^20.3.25",
        "@angular/cdk": "^20.2.14",
        "@angular/common": "^20.3.25",
        "@angular/compiler": "^20.3.25",
        "@angular/core": "^20.3.25",
        "@angular/forms": "^20.3.25",
        "@angular/localize": "^20.3.25",
        "@angular/material": "^20.0.0",
        "@angular/platform-browser": "^20.3.25",
        "@angular/platform-browser-dynamic": "^20.3.25",
        "@angular/router": "^20.3.25",
        "@impacgroup/angular-access-management": "20.0.0",
        "@impacgroup/angular-baselib": "20.0.0",
        "@impacgroup/angular-crashlogs": "20.0.0",
        "@impacgroup/angular-firebase": "20.0.3",
        "@impacgroup/angular-languages": "20.0.0",
        "@impacgroup/angular-mailtemplates": "20.0.2",
        "@impacgroup/angular-oauth-base": "20.0.0",
        "@impacgroup/angular-payment": "20.0.0",
        "@impacgroup/angular-registration": "20.0.0",
        "@impacgroup/angular-selfservice": "20.0.0",
        "@impacgroup/angular-sms": "20.0.0",
        "@impacgroup/angular-systemhealth": "20.0.0",
        "@impacgroup/angular-texts": "20.0.0",
        "@impacgroup/chartist-plugin-tooltip": "1.0.0",
        "@impacgroup/doerr-wildkamera-api-dtos": "3.0.4",
        "@impacgroup/doerr-wildkamera-api-shared": "3.0.4",
        "@ng-select/ng-select": "^20.0.0",
        "@ngx-translate/core": "^17.0.0",
        "@ngx-translate/http-loader": "^17.0.0",
        "animate.css": "^4.1.1",
        "bootstrap": "^5.3.8",
        "chartist": "^1.5.0",
        "chartist-plugin-legend": "^0.6.2",
        "class-transformer": "0.5.1",
        "class-validator": "0.14.3",
        "core-js": "^3.47.0",
        "file-saver": "2.0.5",
        "google-libphonenumber": "3.2.43",
        "jquery": "^3.7.1",
        "material-design-iconic-font": "^2.2.0",
        "moment": "2.30.1",
        "ng-chartist": "^10.0.0",
        "ng5-slider": "^1.2.6",
        "ngx-autosize": "^2.0.4",
        "ngx-bootstrap": "^20.0.0",
        "ngx-dropzone-wrapper": "^17.0.0",
        "ngx-mask": "^20.0.0",
        "ngx-papaparse": "^7.0.0",
        "ngx-quill": "^28.0.0",
        "ngx-scrollbar": "^19.0.0",
        "parchment": "^3.0.0",
        "popper.js": "1.16.1",
        "quill": "^2.0.3",
        "reflect-metadata": "0.2.2",
        "rxjs": "~7.8.1",
        "sourcemapped-stacktrace": "1.1.11",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^20.3.29",
        "@angular/cli": "^20.3.29",
        "@angular/compiler-cli": "^20.3.25",
        "@types/file-saver": "2.0.5",
        "@types/google-libphonenumber": "7.4.23",
        "@types/jasmine": "~4.0.1",
        "@types/jasminewd2": "~2.0.10",
        "@types/jquery": "^3.5.14",
        "@types/node": "^24.13.0",
        "codelyzer": "^6.0.2",
        "grunt": "1.6.1",
        "grunt-cli": "1.4.3",
        "grunt-contrib-clean": "2.0.1",
        "grunt-contrib-compress": "2.0.0",
        "grunt-contrib-copy": "1.0.0",
        "jasmine-core": "~4.0.1",
        "jasmine-spec-reporter": "~7.0.0",
        "karma": "~6.4.2",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "~5.0.1",
        "karma-jasmine-html-reporter": "^2.1.0",
        "ng-packagr": "^20.3.2",
        "prettier": "2.8.8",
        "protractor": "~7.0.0",
        "ts-node": "~10.7.0",
        "tslib": "^2.3.1",
        "tslint": "~6.1.3",
        "typescript": "~5.9.3"
    }
}
